<div class="completed-page">
  <div class="message-box">
    <div class="icon-circle">
      <i class="bi bi-check-lg"></i>
    </div>
    <h1>Interview Completed</h1>
    <p>Your interview has ended successfully. You can safely close this window.</p>
  </div>
</div>